
  import { Component, Prop, Vue } from 'vue-property-decorator';

  import NavbarIcon from './NavbarIcon.vue';

  @Component({
    components: {
      NavbarIcon,
    },
  })
  export default class ChatIcon extends Vue {
    @Prop({ default: false }) readonly isInSideBar!: boolean;

    show: boolean = false;

    goToChat() {
      this.show = !this.show;
    }

    get windowSize() {
      return {
        width: window.innerWidth,
        height: window.innerHeight
      };
    }
  }
